export default [
  { rawLabel: '(UTC-12:00) International Date Line West', baseValue: -12 },
  { rawLabel: '(UTC+13:00) Samoa', baseValue: 13 },
  { rawLabel: '(UTC-11:00) Coordinated Universal Time-11', baseValue: -11 },
  { rawLabel: '(UTC-10:00) Aleutian Islands', baseValue: -10 },
  { rawLabel: '(UTC-10:00) Hawaii', baseValue: -10 },
  { rawLabel: '(UTC-09:30) Marquesas Islands', baseValue: -9 },
  { rawLabel: '(UTC-09:00) Alaska', baseValue: -9 },
  { rawLabel: '(UTC-09:00) Coordinated Universal Time-09', baseValue: -9 },
  { rawLabel: '(UTC-07:00) Yukon', baseValue: -7 },
  { rawLabel: '(UTC-08:00) Baja California', baseValue: -8 },
  { rawLabel: '(UTC-08:00) Coordinated Universal Time-08', baseValue: -8 },
  { rawLabel: '(UTC-08:00) Pacific Time (US & Canada)', baseValue: -8 },
  { rawLabel: '(UTC-07:00) Arizona', baseValue: -7 },
  { rawLabel: '(UTC-07:00) La Paz, Mazatlan', baseValue: -7 },
  { rawLabel: '(UTC-07:00) Mountain Time (US & Canada)', baseValue: -7 },
  { rawLabel: '(UTC-05:00) Chetumal', baseValue: -5 },
  { rawLabel: '(UTC-06:00) Central America', baseValue: -6 },
  { rawLabel: '(UTC-06:00) Central Time (US & Canada)', baseValue: -6 },
  { rawLabel: '(UTC-06:00) Easter Island', baseValue: -6 },
  {
    rawLabel: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    baseValue: -6,
  },
  { rawLabel: '(UTC-06:00) Saskatchewan', baseValue: -6 },
  { rawLabel: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', baseValue: -5 },
  { rawLabel: '(UTC-05:00) Eastern Time (US & Canada)', baseValue: -5 },
  { rawLabel: '(UTC-05:00) Haiti', baseValue: -5 },
  { rawLabel: '(UTC-05:00) Havana', baseValue: -5 },
  { rawLabel: '(UTC-05:00) Indiana (East)', baseValue: -5 },
  { rawLabel: '(UTC-05:00) Turks and Caicos', baseValue: -5 },
  { rawLabel: '(UTC-04:00) Caracas', baseValue: -4 },
  { rawLabel: '(UTC-03:00) Punta Arenas', baseValue: -3 },
  { rawLabel: '(UTC-04:00) Asuncion', baseValue: -4 },
  { rawLabel: '(UTC-04:00) Atlantic Time (Canada)', baseValue: -4 },
  { rawLabel: '(UTC-04:00) Cuiaba', baseValue: -4 },
  {
    rawLabel: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    baseValue: -4,
  },
  { rawLabel: '(UTC-04:00) Santiago', baseValue: -4 },
  { rawLabel: '(UTC-03:30) Newfoundland', baseValue: -3 },
  { rawLabel: '(UTC-03:00) Araguaina', baseValue: -3 },
  { rawLabel: '(UTC-03:00) Brasilia', baseValue: -3 },
  { rawLabel: '(UTC-03:00) Cayenne, Fortaleza', baseValue: -3 },
  { rawLabel: '(UTC-03:00) City of Buenos Aires', baseValue: -3 },
  { rawLabel: '(UTC-02:00) Greenland', baseValue: -2 },
  { rawLabel: '(UTC-03:00) Montevideo', baseValue: -3 },
  { rawLabel: '(UTC-03:00) Saint Pierre and Miquelon', baseValue: -3 },
  { rawLabel: '(UTC-03:00) Salvador', baseValue: -3 },
  { rawLabel: '(UTC-02:00) Coordinated Universal Time-02', baseValue: -2 },
  { rawLabel: '(UTC-02:00) Mid-Atlantic - Old', baseValue: -2 },
  { rawLabel: '(UTC-01:00) Azores', baseValue: -1 },
  { rawLabel: '(UTC-01:00) Cabo Verde Is.', baseValue: -1 },
  { rawLabel: '(UTC) Coordinated Universal Time', baseValue: 0 },
  { rawLabel: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', baseValue: 0 },
  { rawLabel: '(UTC+00:00) Monrovia, Reykjavik', baseValue: 0 },
  { rawLabel: '(UTC+01:00) Casablanca', baseValue: 1 },
  {
    rawLabel: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    baseValue: 1,
  },
  {
    rawLabel: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    baseValue: 1,
  },
  { rawLabel: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', baseValue: 1 },
  { rawLabel: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', baseValue: 1 },
  { rawLabel: '(UTC+01:00) West Central Africa', baseValue: 1 },
  { rawLabel: '(UTC+02:00) Tripoli', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Windhoek', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Athens, Bucharest', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Beirut', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Cairo', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Chisinau', baseValue: 2 },
  { rawLabel: '(UTC+03:00) Damascus', baseValue: 3 },
  { rawLabel: '(UTC+02:00) Gaza, Hebron', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Harare, Pretoria', baseValue: 2 },
  {
    rawLabel: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    baseValue: 2,
  },
  { rawLabel: '(UTC+02:00) Jerusalem', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Juba', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Kaliningrad', baseValue: 2 },
  { rawLabel: '(UTC+02:00) Khartoum', baseValue: 2 },
  { rawLabel: '(UTC+03:00) Amman', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Istanbul', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Minsk', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Baghdad', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Kuwait, Riyadh', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Moscow, St. Petersburg', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Nairobi', baseValue: 3 },
  { rawLabel: '(UTC+03:00) Volgograd', baseValue: 3 },
  { rawLabel: '(UTC+04:00) Astrakhan, Ulyanovsk', baseValue: 4 },
  { rawLabel: '(UTC+04:00) Izhevsk, Samara', baseValue: 4 },
  { rawLabel: '(UTC+04:00) Saratov', baseValue: 4 },
  { rawLabel: '(UTC+03:30) Tehran', baseValue: 3 },
  { rawLabel: '(UTC+04:00) Abu Dhabi, Muscat', baseValue: 4 },
  { rawLabel: '(UTC+04:00) Baku', baseValue: 4 },
  { rawLabel: '(UTC+04:00) Port Louis', baseValue: 4 },
  { rawLabel: '(UTC+04:00) Tbilisi', baseValue: 4 },
  { rawLabel: '(UTC+04:00) Yerevan', baseValue: 4 },
  { rawLabel: '(UTC+04:30) Kabul', baseValue: 4 },
  { rawLabel: '(UTC+05:00) Ashgabat, Toshkent', baseValue: 5 },
  { rawLabel: '(UTC+05:00) Astana', baseValue: 5 },
  { rawLabel: '(UTC+05:00) Ekaterinburg', baseValue: 5 },
  { rawLabel: '(UTC+05:00) Islamabad, Karachi', baseValue: 5 },
  { rawLabel: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', baseValue: 5 },
  { rawLabel: '(UTC+05:30) Sri Jayawardenepura', baseValue: 5 },
  { rawLabel: '(UTC+05:45) Kathmandu', baseValue: 5 },
  { rawLabel: '(UTC+06:00) Bishkek', baseValue: 6 },
  { rawLabel: '(UTC+06:00) Dhaka', baseValue: 6 },
  { rawLabel: '(UTC+06:00) Omsk', baseValue: 6 },
  { rawLabel: '(UTC+07:00) Barnaul, Gorno-Altaysk', baseValue: 7 },
  { rawLabel: '(UTC+07:00) Novosibirsk', baseValue: 7 },
  { rawLabel: '(UTC+07:00) Tomsk', baseValue: 7 },
  { rawLabel: '(UTC+06:30) Yangon (Rangoon)', baseValue: 6 },
  { rawLabel: '(UTC+07:00) Bangkok, Hanoi, Jakarta', baseValue: 7 },
  { rawLabel: '(UTC+07:00) Hovd', baseValue: 7 },
  { rawLabel: '(UTC+07:00) Krasnoyarsk', baseValue: 7 },
  {
    rawLabel: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    baseValue: 8,
  },
  { rawLabel: '(UTC+08:00) Irkutsk', baseValue: 8 },
  { rawLabel: '(UTC+08:00) Kuala Lumpur, Singapore', baseValue: 8 },
  { rawLabel: '(UTC+08:00) Perth', baseValue: 8 },
  { rawLabel: '(UTC+08:00) Taipei', baseValue: 8 },
  { rawLabel: '(UTC+08:00) Ulaanbaatar', baseValue: 8 },
  { rawLabel: '(UTC+09:00) Chita', baseValue: 9 },
  { rawLabel: '(UTC+09:00) Pyongyang', baseValue: 9 },
  { rawLabel: '(UTC+08:45) Eucla', baseValue: 8 },
  { rawLabel: '(UTC+09:00) Osaka, Sapporo, Tokyo', baseValue: 9 },
  { rawLabel: '(UTC+09:00) Seoul', baseValue: 9 },
  { rawLabel: '(UTC+09:00) Yakutsk', baseValue: 9 },
  { rawLabel: '(UTC+09:30) Adelaide', baseValue: 9 },
  { rawLabel: '(UTC+09:30) Darwin', baseValue: 9 },
  { rawLabel: '(UTC+10:00) Brisbane', baseValue: 10 },
  { rawLabel: '(UTC+10:00) Canberra, Melbourne, Sydney', baseValue: 10 },
  { rawLabel: '(UTC+10:00) Guam, Port Moresby', baseValue: 10 },
  { rawLabel: '(UTC+10:00) Hobart', baseValue: 10 },
  { rawLabel: '(UTC+10:00) Vladivostok', baseValue: 10 },
  { rawLabel: '(UTC+11:00) Bougainville Island', baseValue: 11 },
  { rawLabel: '(UTC+11:00) Magadan', baseValue: 11 },
  { rawLabel: '(UTC+11:00) Sakhalin', baseValue: 11 },
  { rawLabel: '(UTC+10:30) Lord Howe Island', baseValue: 10 },
  { rawLabel: '(UTC+11:00) Chokurdakh', baseValue: 11 },
  { rawLabel: '(UTC+11:00) Norfolk Island', baseValue: 11 },
  { rawLabel: '(UTC+11:00) Solomon Is., New Caledonia', baseValue: 11 },
  { rawLabel: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', baseValue: 12 },
  { rawLabel: '(UTC+12:00) Auckland, Wellington', baseValue: 12 },
  { rawLabel: '(UTC+12:00) Coordinated Universal Time+12', baseValue: 12 },
  { rawLabel: '(UTC+12:00) Fiji', baseValue: 12 },
  { rawLabel: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', baseValue: 12 },
  { rawLabel: '(UTC+12:45) Chatham Islands', baseValue: 12 },
  { rawLabel: '(UTC+13:00) Coordinated Universal Time+13', baseValue: 13 },
  { rawLabel: '(UTC+13:00) Nuku’alofa', baseValue: 13 },
  { rawLabel: '(UTC+14:00) Kiritimati Island', baseValue: 14 },
];
